export default {
  init() {
    // JavaScript to be fired on the
  },
  finalize() {
    // JavaScript to be fired on the , after the init JS
    $('#faqAccordion')
      .on('hide.bs.collapse', e => $(e.target).closest('.card').removeClass('shownAccordion'))
      .on('show.bs.collapse', e => $(e.target).closest('.card').addClass('shownAccordion'));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/faq.js